import React from 'react';
import { Cpu, ShoppingCart, Factory, Car, Activity, Shirt } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const SectorsSection = () => {
  const { language } = useLanguage();

  const sectorsData = {
    tr: {
      title: 'Sektörler',
      subtitle: 'Farklı sektörlere özel lojistik çözümleri sunuyoruz.',
      sectors: [
        { id: 1, name: 'Elektronik', icon: 'Cpu', description: 'Hassas elektronik ürünler için özel taşıma' },
        { id: 2, name: 'FMCG', icon: 'ShoppingCart', description: 'Hızlı tüketim ürünleri lojistiği' },
        { id: 3, name: 'İmalat', icon: 'Factory', description: 'Endüstriyel ürün taşımacılığı' },
        { id: 4, name: 'Otomotiv', icon: 'Car', description: 'Otomotiv sektörü lojistik çözümleri' },
        { id: 5, name: 'Sağlık', icon: 'Activity', description: 'Medikal ürün taşıma hizmetleri' },
        { id: 6, name: 'Tekstil', icon: 'Shirt', description: 'Tekstil sektörü taşımacılık' }
      ]
    },
    en: {
      title: 'Sectors',
      subtitle: 'We provide specialized logistics solutions for different sectors.',
      sectors: [
        { id: 1, name: 'Electronics', icon: 'Cpu', description: 'Special transportation for sensitive electronics' },
        { id: 2, name: 'FMCG', icon: 'ShoppingCart', description: 'Fast moving consumer goods logistics' },
        { id: 3, name: 'Manufacturing', icon: 'Factory', description: 'Industrial product transportation' },
        { id: 4, name: 'Automotive', icon: 'Car', description: 'Automotive sector logistics solutions' },
        { id: 5, name: 'Healthcare', icon: 'Activity', description: 'Medical product transportation services' },
        { id: 6, name: 'Textile', icon: 'Shirt', description: 'Textile sector transportation' }
      ]
    }
  };

  const iconMap = { Cpu, ShoppingCart, Factory, Car, Activity, Shirt };
  const content = sectorsData[language];

  return (
    <section id="sectors" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#36344D] mb-4">
            {content.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {content.sectors.map((sector) => {
            const IconComponent = iconMap[sector.icon];
            return (
              <div
                key={sector.id}
                className="group bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#DF6A6A]"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-[#DF6A6A]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#DF6A6A] transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-[#DF6A6A] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-[#36344D] mb-2 group-hover:text-[#DF6A6A] transition-colors">
                    {sector.name}
                  </h3>
                  <p className="text-gray-600 text-sm">{sector.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectorsSection;